import { PageHero } from '../components/ui/PageHero';
import { ProductCard } from '../components/ui/ProductCard';
import { AnimatedCard } from '../components/ui/AnimatedCard';
import { CTAButton } from '../components/ui/CTAButton';
import { PRODUCTS } from '../constants/content';

export default function ProductsPage() {
  return (
    <>
      <PageHero
        title="萌趣冥想随行伙伴"
        subtitle="精选萌系水果毛绒与收藏玩偶，榴莲、山竹等高辨识度造型，为你的冥想空间增添温暖陪伴与治愈仪式感。"
        breadcrumb={[{ label: '首页', path: '/' }, { label: '产品设备' }]}
      />

      <section className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-purple-200 leading-relaxed mb-4">
            每一款周边均经独立设计打样，优质超柔面料与精细做工，是 APP 用户的理想收藏与赠礼之选。
            水果系列以高饱和度配色与萌趣造型为特色，与 Ameowzing 冥想 APP 共同营造线上线下联动的正念仪式感。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto mb-16">
          {PRODUCTS.map((product) => (
            <ProductCard key={product.slug} product={product} />
          ))}
        </div>

        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-bold text-center mb-8">系列亮点</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
            {[
              {
                icon: 'fa-paint-brush',
                title: '独立设计',
                desc: '每款公仔均经过多轮打样，确保造型辨识度高、细节精致。',
              },
              {
                icon: 'fa-heart',
                title: '超柔材质',
                desc: '优质毛绒面料，亲肤柔软，拥抱感满满，适合全年龄段收藏。',
              },
              {
                icon: 'fa-gift',
                title: '送礼佳选',
                desc: '精美包装可选，适合生日、节日、企业礼品等场景。',
              },
            ].map((item) => (
              <AnimatedCard
                key={item.title}
                className="bg-white/5 rounded-2xl p-6 border border-purple-500/20 text-center"
              >
                <i className={`fa ${item.icon} text-3xl text-secondary mb-3`} />
                <h3 className="font-semibold mb-2">{item.title}</h3>
                <p className="text-purple-300 text-sm">{item.desc}</p>
              </AnimatedCard>
            ))}
          </div>

          <div className="bg-gradient-to-r from-primary/20 to-secondary/20 rounded-3xl p-10 border border-purple-500/20 text-center">
            <h3 className="text-xl font-semibold mb-4">咨询采购</h3>
            <p className="text-purple-200 text-sm mb-6">
              支持零售咨询、批量订购与企业定制。请邮件注明产品名称、数量与用途，我们将尽快回复报价。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <CTAButton to="/inquiry" variant="primary" icon="fa-shopping-cart">
                购买咨询
              </CTAButton>
              <CTAButton to="/contact/gift" variant="secondary" icon="fa-gift">
                礼品批量采购
              </CTAButton>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
